module.exports = __webpack_public_path__ + "img/7.16810d38.svg";